<template>
  <div
    class="modal fade"
    id="deleteProfileimg"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    @click="handleModalClick"
  >
    <div class="modal-dialog leaveModal" role="document">
      <div class="modal-content">
        <div class="leaveModal-header">
          <button
            type="button"
            class="close"
            id="deleteProfileimgClose"
            @click="closeModal"
            aria-label="Close"
          >
            <img src="@/assets/lems-v1/images/close-black-icon.svg" alt="" />
          </button>
          <h1>
            {{ constants.DELETE_PICTURE_TEXT }}
          </h1>
        </div>
        <div class="leaveModal-btm">
          <button
            @click="closeModal"
            aria-label="Close"
            class="v1-button-outline-black"
            id="deleteProfileCancel"
          >
            {{ constants.CANCEL_BUTTON }}
          </button>
          <button
            @click="confirmDelete"
            class="v1-button-outline"
            id="deleteProfileYes"
          >
            {{ constants.YES_LINK }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import eventBus from "@/utils/eventBus";

export default defineComponent({
  name: "DeleteConfirmPopup",
  data() {
    return {
      constants,
    };
  },
  methods: {
    confirmDelete() {
      eventBus.emit("profile-image-delete-confirmed");
      this.closeModal();
    },

    closeModal() {
      const modal = document.getElementById("deleteProfileimg");
      if (modal) {
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) {
          backdrop.remove();
        }

        // Hide modal
        modal.classList.remove("show");
        modal.style.display = "none";
        modal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("modal-open");
      }
    },

    handleModalClick(event: Event) {
      // Close modal when clicking on the backdrop (outside the modal content)
      if (event.target === event.currentTarget) {
        this.closeModal();
      }
    },
  },
});
</script>
